import React from 'react'
import { API_url } from '../api.setup';
import { enqueueSnackbar } from 'notistack';
import axios from 'axios';

const API_Controller = '/users';


const userManagementServices = {
  getAllUsers: async () => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getall`);
      return response.data;
    } catch (error) {
      enqueueSnackbar('Error fetching users', { variant: 'error' });
      throw error;
    }
  },

  getUser: async (id) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/get?id=${id}`);
      return response.data;
    } catch (error) {
      enqueueSnackbar('Error fetching user details', { variant: 'error' });
      throw error;
    }
  },

  createUser: async (userData) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/create`,
        userData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateUser: async (userData) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/update`,
        userData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteUser: async (id) => {
    try {
      const response = await axios.delete(
        `${API_url}${API_Controller}/delete?id=${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (userId) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/reset-password?userId=${userId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  changePassword: async (changePasswordData) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/change-password`,
        changePasswordData
      );
      return response.data;
    } catch (error) {
      enqueueSnackbar('Error changing password', { variant: 'error' });
      throw error;
    }
  },

  login: async (loginData: { Email: string; Password: string }) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/login`,
        loginData
      );
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || 'Error logging in';
      enqueueSnackbar(message, { variant: 'error' });
      throw error;
    }
  },

}

export default userManagementServices